import ReactSpeedometer from "react-d3-speedometer";

type GaugeProps = {
  id: string;
  label: string;
  units?: string;
  minValue?: number;
  maxValue?: number;
  width?: number;
  height?: number;
  majorStep?: number;
  value?: number;
};

export default function Gauge({
  label,
  units = "Mbps",
  minValue = 0,
  maxValue = 100,
  width = 200,
  height = 160,
  majorStep = 10,
  value = 0,
}: GaugeProps) {
  const segments = Math.floor((maxValue - minValue) / majorStep);

  return (
    <div className="testArea relative flex flex-col items-center">
      <div className="text-xl font-semibold text-orange-500 mb-2">{label}</div>
      <ReactSpeedometer
        minValue={minValue}
        maxValue={maxValue}
        value={value}
        segments={segments}
        needleColor="red"
        startColor="green"
        endColor="blue"
        width={width}
        height={height}
        currentValueText={`مقدار: ${value} ${units}`}
        ringWidth={20}
        needleTransitionDuration={1000}
        forceRender={true}
      />
    </div>
  );
}
